const translations = {
  fr: {
    proposition: {
      acceptTheProposition: 'accepter la proposition',
      cancelTheProposition: 'annuler la proposition',
      declineTheProposition: 'refuser la proposition',
      sendTheProposition: 'envoyer la proposition',
      customerWillBeAbleToAccessPropositionOnFollo: '{{name}} aura accès à la proposition dans Follo',
    },
  },
  en: {
    proposition: {
      acceptTheProposition: 'accept the proposal',
      cancelTheProposition: 'cancel the proposal',
      declineTheProposition: 'decline the proposal',
      sendTheProposition: 'send the proposal',
      customerWillBeAbleToAccessPropositionOnFollo: '{{name}} will be able to access proposition in Follo',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/proposition/i18n/proposition.js